export default "__VITE_ASSET__C$EwoPG2__"